import { gql, TypedDocumentNode } from "@apollo/client";

export interface ExcludeUniversityEventStudentsMutationData {
  excludeUniversityEventStudents: {
    success: boolean;
    message: string | null;
    code: string;
    excludedCount: number;
    alreadyExcludedCount: number;
  };
}

export interface ExcludeUniversityEventStudentsMutationVariables {
  input: {
    universityId: string;
    eventSlug: string;
    personIds: string[];
  };
}

export const EXCLUDE_UNIVERSITY_EVENT_STUDENTS_MUTATION: TypedDocumentNode<
  ExcludeUniversityEventStudentsMutationData,
  ExcludeUniversityEventStudentsMutationVariables
> = gql`
  mutation ExcludeUniversityEventStudents($input: BackofficeEducationExcludeUniversityEventStudentsInput!) {
    excludeUniversityEventStudents(input: $input) {
      success
      message
      code
      excludedCount
      alreadyExcludedCount
    }
  }
`;
